import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ticketsApi } from "../utils/api";

export default function OrgLoginPage() {
  const navigate = useNavigate();
  const [tab, setTab]       = useState("login");
  const [form, setForm]     = useState({email:"", password:""});
  const [reg, setReg]       = useState({name:"", email:"", phone:"", password:""});
  const [error, setError]   = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async e => {
    e.preventDefault(); setLoading(true); setError("");
    try {
      const d = await ticketsApi.managerLogin(form.email, form.password);
      localStorage.setItem("organiser_token", d.token);
      localStorage.setItem("organiser_name", d.organiser.name);
      navigate("/manage");
    } catch(err) { setError(err.message); }
    finally { setLoading(false); }
  };

  const handleRegister = async e => {
    e.preventDefault(); setLoading(true); setError("");
    try {
      await fetch("/api/tickets/manage/register", {
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body: JSON.stringify(reg)
      }).then(r => r.json());
      setSuccess("Registration submitted! Our team will review your account within 24 hours.");
    } catch(err) { setError(err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex" style={{background:"#07000f"}}>
      {/* Left decorative panel */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden items-center justify-center"
        style={{background:"linear-gradient(135deg,#0d0020,#1a0035)"}}>
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full blur-3xl opacity-30"
            style={{background:"radial-gradient(circle,#9b3fe8,transparent)"}}/>
          <div className="absolute bottom-1/4 right-1/4 w-48 h-48 rounded-full blur-3xl opacity-20"
            style={{background:"radial-gradient(circle,#f59e0b,transparent)"}}/>
          <div className="absolute inset-0" style={{backgroundImage:"linear-gradient(rgba(155,63,232,0.05) 1px,transparent 1px),linear-gradient(90deg,rgba(155,63,232,0.05) 1px,transparent 1px)", backgroundSize:"40px 40px"}}/>
        </div>
        <div className="relative z-10 text-center px-12">
          <img src="/logos/logo-main.png" alt="NagNail Tickets" style={{height:"80px", width:"auto", margin:"0 auto 32px"}}/>
          <h2 className="font-display text-4xl font-bold text-white mb-4">Grow Your Events</h2>
          <p className="text-gray-400 text-lg mb-10 leading-relaxed">
            Join hundreds of organisers using NagNail Tickets to sell out their events across Sri Lanka.
          </p>
          <div className="space-y-4 text-left">
            {[
              {icon:"🎟️", title:"Easy Ticket Setup",    desc:"Create events with multiple tiers in minutes"},
              {icon:"📱", title:"WhatsApp QR Delivery", desc:"Tickets sent automatically to attendees"},
              {icon:"📊", title:"Real-time Analytics",  desc:"Track sales, check-ins and revenue live"},
              {icon:"💰", title:"Fast Payouts",         desc:"Get paid within 3-5 business days"},
            ].map(f => (
              <div key={f.title} className="flex items-start gap-3 glass rounded-xl p-3">
                <span className="text-xl">{f.icon}</span>
                <div>
                  <p className="text-white font-semibold text-sm">{f.title}</p>
                  <p className="text-gray-500 text-xs">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right: Form */}
      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-md">
          <div className="text-center mb-8 lg:hidden">
            <img src="/logos/logo-main.png" alt="NagNail Tickets" style={{height:"60px", width:"auto", margin:"0 auto 16px"}}/>
          </div>

          <h1 className="font-display text-3xl font-bold text-white mb-2">
            {tab === "login" ? "Welcome back" : "Get started"}
          </h1>
          <p className="text-gray-400 mb-8">
            {tab === "login" ? "Sign in to your organiser account" : "Create your organiser account"}
          </p>

          {/* Tabs */}
          <div className="flex glass rounded-xl p-1 mb-6">
            {["login","register"].map(t => (
              <button key={t} onClick={() => {setTab(t); setError(""); setSuccess("");}}
                className={`flex-1 py-2.5 rounded-lg text-sm font-semibold capitalize transition ${
                  tab === t ? "text-white" : "text-gray-500 hover:text-gray-300"
                }`}
                style={tab === t ? {background:"linear-gradient(135deg,#7c22c8,#9b3fe8)"} : {}}>
                {t === "login" ? "Sign In" : "Register"}
              </button>
            ))}
          </div>

          {error && (
            <div className="rounded-xl p-4 mb-5 flex items-center gap-3" style={{background:"rgba(239,68,68,0.08)", border:"1px solid rgba(239,68,68,0.2)"}}>
              <span>⚠️</span><p className="text-red-300 text-sm">{error}</p>
            </div>
          )}

          {success ? (
            <div className="text-center py-8 glass rounded-2xl">
              <p className="text-5xl mb-4">🎉</p>
              <p className="text-green-300 font-bold text-lg mb-2">Application Submitted!</p>
              <p className="text-gray-400 text-sm px-4">{success}</p>
            </div>
          ) : tab === "login" ? (
            <form onSubmit={handleLogin} className="space-y-4">
              {[
                {label:"Email Address", field:"email",    type:"email",    placeholder:"you@company.lk"},
                {label:"Password",      field:"password", type:"password", placeholder:"••••••••"},
              ].map(f => (
                <div key={f.field}>
                  <label className="text-xs text-gray-400 font-medium mb-1.5 block">{f.label}</label>
                  <input type={f.type} placeholder={f.placeholder} value={form[f.field]}
                    onChange={e => setForm({...form, [f.field]:e.target.value})} required
                    className="w-full px-4 py-3 rounded-xl text-white text-sm placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-brand-500"
                    style={{background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.1)"}}/>
                </div>
              ))}
              <button type="submit" disabled={loading}
                className="w-full py-4 rounded-xl font-bold text-white text-base transition hover:scale-[1.01] disabled:opacity-60 mt-2"
                style={{background:"linear-gradient(135deg,#7c22c8,#9b3fe8)", boxShadow:"0 8px 24px rgba(124,34,200,0.3)"}}>
                {loading ? "Signing in..." : "Sign In →"}
              </button>
            </form>
          ) : (
            <form onSubmit={handleRegister} className="space-y-4">
              {[
                {label:"Organisation / Name", field:"name",     type:"text",     placeholder:"EventPro LK"},
                {label:"Email Address",       field:"email",    type:"email",    placeholder:"you@company.lk"},
                {label:"Phone Number",        field:"phone",    type:"tel",      placeholder:"+94 77 123 4567"},
                {label:"Password",            field:"password", type:"password", placeholder:"Min 8 characters"},
              ].map(f => (
                <div key={f.field}>
                  <label className="text-xs text-gray-400 font-medium mb-1.5 block">{f.label}</label>
                  <input type={f.type} placeholder={f.placeholder} value={reg[f.field]}
                    onChange={e => setReg({...reg, [f.field]:e.target.value})} required
                    className="w-full px-4 py-3 rounded-xl text-white text-sm placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-brand-500"
                    style={{background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.1)"}}/>
                </div>
              ))}
              <p className="text-xs text-gray-600">Account requires admin approval before you can list events. Usually within 24 hours.</p>
              <button type="submit" disabled={loading}
                className="w-full py-4 rounded-xl font-bold text-white text-base transition hover:scale-[1.01] disabled:opacity-60"
                style={{background:"linear-gradient(135deg,#7c22c8,#9b3fe8)", boxShadow:"0 8px 24px rgba(124,34,200,0.3)"}}>
                {loading ? "Submitting..." : "Request Access →"}
              </button>
            </form>
          )}

          <p className="text-center text-gray-600 text-xs mt-6">
            <Link to="/" className="hover:text-gray-400 transition">← Back to public site</Link>
          </p>
        </div>
      </div>
    </div>
  );
}